import SideNavigationMenuItem, {
    SideNavigationMenuItemConfig,
} from "./SideNavigationMenuItem";

type SideNavigationMenuProps = {
    items: SideNavigationMenuItemConfig[];
};

const SideNavigationMenu = ({ items }: SideNavigationMenuProps) => {
    return (
        <ul className="flex sm:flex-col gap-[0.625rem]">
            {items.map((item) => (
                <SideNavigationMenuItem
                    key={`side-nav-item-${item.label}`}
                    {...item}
                />
            ))}
        </ul>
    );
};

export default SideNavigationMenu;
